import { useDeployState, safeReload } from "@/lib/stability/deployVersion";

/**
 * StaleBuildBanner — surfaces a non-intrusive prompt when the running
 * bundle no longer matches the latest deployed build. User initiates
 * the reload; we never force it.
 */
export function StaleBuildBanner() {
  const { stale } = useDeployState();
  if (!stale) return null;
  return (
    <div className="fixed bottom-20 left-1/2 z-[80] -translate-x-1/2 rounded-full border border-border bg-background/95 px-4 py-2 text-[12px] shadow-lg backdrop-blur">
      <span className="font-semibold">Nueva versión disponible.</span>{" "}
      <button
        onClick={() => { void safeReload(); }}
        className="ml-2 rounded-full bg-primary px-3 py-1 text-[11px] font-semibold text-primary-foreground"
      >
        Actualizar
      </button>
    </div>
  );
}
